import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature } from '@openfeature/react-sdk';

/**
 * Release gate for honouring the four-toggle copy settings on text-menu
 * selection copy (vMarkdown and markdown-native). Default OFF: text-menu
 * Copy falls through to historical WITH_LISTS (Scribe improved-copy and
 * Athena still apply there; vMarkdown also honours
 * `op-scribe-disable-vmde-shortcut-copy-type`). Shortcut copy, cut, and
 * context-menu Copy are not gated by this flag.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the
 * getter does not add a `react-refresh/only-export-components` warning.
 * Import it from `@/features/flags/selection-copy-settings`.
 */
export const isSelectionCopySettingsEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-selection-copy-settings',
    false
  );
